import * as React from "react"
import SubmissionForm from "@jukin/submission-form"
export default class IndexPage extends React.PureComponent {

  render() {
    return (
      <div className="container">
        <span className="header-title">Submit Video</span>
        <hr class="divider"/>
        <SubmissionForm
          site="People Are Awesome"
          riffUrl={process.env.GATSBY_RIFF_URL}
          submissionSource="peopleareawesome"
          uploadPrefix={process.env.GATSBY_UPLOAD_PREFIX}
          tos="https://peopleareawesome.com/terms-of-service/"
          privacyPolicy="https://peopleareawesome.com/privacy-policy/"
          mailchimpUrl={process.env.GATSBY_MAILCHIMP_URL}
          mailchimpListID={process.env.GATSBY_MAILCHIMP_LIST_ID}
          typeform={process.env.GARSBY_TYPEFORM}
          isNewsletterSignUpRequired={false}
        />
      </div>
    )
  }
}
